import request from '@/utils/request'

// 查询大赛作品申报字段配置列表
export function listWorkfield(url,query) {
  return request({
    url: url+'/workfield/list',
    method: 'get',
    params: query
  })
}

// 查询大赛作品申报字段配置列表
export function listWorkfieldNew(url,query) {
  return request({
    url: url+'/workfield/listNew',
    method: 'get',
    params: query
  })
}

// 查询大赛作品申报字段配置详细
export function getWorkfield(url,id) {
  return request({
    url: url+'/workfield/' + id,
    method: 'get'
  })
}

// 查询大赛作品申报字段是否重复
export function workfieldCountFieldNum(url,query) {
  return request({
    url: url+'/workfield/countFieldNum',
    method: 'get',
    params: query

  })
}

// 新增大赛作品申报字段配置
export function addWorkfield(url,data) {
  return request({
    url: url+'/workfield',
    method: 'post',
    data: data
  })
}

// 修改大赛作品申报字段配置
export function updateWorkfield(url,data) {
  return request({
    url: url+'/workfield',
    method: 'put',
    data: data
  })
}

// 删除大赛作品申报字段配置
export function delWorkfield(url,id) {
  return request({
    url: url+'/workfield/' + id,
    method: 'delete'
  })
}

// 查询大赛作品申报字段互斥列表
export function checkExclusionFieldAll(url,query) {
  return request({
    url: url+'/workfield/checkExclusionFieldAll',
    method: 'get',
    params: query
  })
}

// 查询参加几届大赛
export function getWorkLists(url,userId) {
  return request({
    url: url+'/workdata/getWorkLists/' + userId,
    method: 'get'
  })
}

// // 查询参加几届大赛的用户id
// export function getInfo(url) {
//   return request({
//     url: url+'/user/getInfo',
//     method: 'get'
//   })
// }
//获取用户信息
export function getUserInfo (url) {
  return request({
    url: url + '/system/user/getInfo',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/work/workfield.js